export const getEmailFormData = (formData, values) => {
  const {
    subject,
    body,
    attachments,
    cc,
    bcc,
    appIds,
    bulk_exempted_application_ids,
    bulk_selected_ats_job_stage_ids,
    bulk_selected_application_statuses,
    sender_id,
    selectedTemplate = {},
    schedule_at = {},
    ats_shared_email_id = undefined,
    is_bulk_activity,
    ats_job_id,
    source_job_id,
  } = values;
  let hasTemplateAttachments = false;
  formData.append('sender_id', sender_id);
  if (is_bulk_activity) {
    formData.append('is_bulk_activity', is_bulk_activity);
  }
  if (ats_job_id) {
    formData.append('ats_job_id', ats_job_id);
  }
  if (source_job_id) {
    formData.append('source_job_id', source_job_id);
  }
  formData.append('subject', subject);
  formData.append('body', body);
  cc?.forEach((id) => formData.append('cc[]', id));
  bcc?.forEach((id) => formData.append('bcc[]', id));
  // this is for shared emails, will come dynamically
  if (ats_shared_email_id) {
    formData.append('ats_shared_email_id', ats_shared_email_id);
  }
  if (schedule_at?.formattedTime) {
    formData.append('scheduled_at', schedule_at?.formattedTime);
    formData.append('timezone', schedule_at?.timezoneValue?.key);
  }
  attachments.forEach((file) => {
    if (file instanceof File) formData.append('attachments[]', file);
    if (file?.id) {
      hasTemplateAttachments = true;
      formData.append('attachments[]', file?.id);
    }
  });
  if (selectedTemplate?.id && hasTemplateAttachments) {
    formData.append('ats_comm_template_id', selectedTemplate?.id);
  }
  if (bulk_exempted_application_ids) {
    bulk_exempted_application_ids?.forEach((id) =>
      formData.append('bulk_exempted_application_ids[]', id)
    );
    bulk_selected_ats_job_stage_ids?.forEach((id) =>
      formData.append('bulk_selected_ats_job_stage_ids[]', id)
    );
    bulk_selected_application_statuses?.forEach((id) =>
      formData.append('bulk_selected_application_statuses[]', id)
    );
  } else {
    appIds?.forEach((id) => formData.append('ats_application_ids[]', id));
  }
  return formData;
};
